export const DEFAULT_WRITING_FONT = 'open_dyslexic'

const WRITING_FONT_FAMILIES = {
  open_dyslexic: '"OpenDyslexic", sans-serif',
  jetbrains_mono: '"JetBrains Mono", monospace',
  atkinson_hyperlegible: '"Atkinson Hyperlegible", sans-serif',
}

/** Catalog keys only (no system fonts). */
export const WRITING_FONT_KEYS = Object.freeze([
  'open_dyslexic',
  'jetbrains_mono',
  'atkinson_hyperlegible',
])

export const WRITING_FONT_LABELS = Object.freeze({
  open_dyslexic: 'Open Dyslexic',
  jetbrains_mono: 'JetBrains Mono',
  atkinson_hyperlegible: 'Atkinson Hyperlegible',
})

/**
 * Map a catalog writing-font key to a CSS font-family stack.
 * Blank/unknown values fall back to Open Dyslexic.
 */
export function writingFontFamily(key) {
  if (key && WRITING_FONT_FAMILIES[key]) {
    return WRITING_FONT_FAMILIES[key]
  }
  return WRITING_FONT_FAMILIES[DEFAULT_WRITING_FONT]
}

export function resolveWritingFontKey(key) {
  if (key && WRITING_FONT_FAMILIES[key]) {
    return key
  }
  return DEFAULT_WRITING_FONT
}

/** Persist preference via existing Settings endpoint (form-encoded). */
export async function updateWritingFontPreference(fontKey, { axiosClient } = {}) {
  const client = axiosClient || (await import('axios')).default
  const key = resolveWritingFontKey(fontKey)
  const body = new URLSearchParams()
  body.set('user[writing_font]', key)
  const response = await client.patch('/settings/writing_font', body, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'text/html, application/xhtml+xml',
    },
    // Rails redirects to settings; follow is fine for cookie session
    maxRedirects: 5,
    validateStatus: (status) => status >= 200 && status < 400,
  })
  return { key, response }
}
